import styled from 'styled-components';
import { FileUpload } from 'primereact/fileupload';

/**
 * @deprecated Use FileUploadV2 instead
 */
export const PFileUploadStyle = {
  FileUpload: styled(FileUpload)``,
};
